var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-list-container",attrs:{"id":"data-list-thumb-view"}},[_c('div',{staticClass:"vx-row"},[_c('div',{staticClass:"vx-col w-full mb-base"},[_c('SearchByProduct',{on:{"ordersResult":_vm.ordersResult,"clear":_vm.clear}})],1)]),_c('Table',{attrs:{"path":"equipamentos","orders":_vm.orders}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }